import { Encoder, Set } from '@everyboard/lib';
import { Coord } from '../../jscaip/Coord';
import { Move } from '../../jscaip/Move';
import { MoveCoordToCoord } from '../../jscaip/MoveCoordToCoord';
export class QuebecCastlesTranslation extends MoveCoordToCoord {
    static of(start, end) {
        return new QuebecCastlesTranslation(start, end);
    }
    constructor(start, end) {
        super(start, end);
    }
    toString() {
        return 'QuebecCastlesTranslation(' + this.getStart().toString() + ' -> ' + this.getEnd().toString() + ')';
    }
    equals(other) {
        if (other instanceof QuebecCastlesTranslation) {
            return super.equals(other);
        }
        else {
            return false;
        }
    }
}
export class QuebecCastlesDrop extends Move {
    coords;
    static encoder = Encoder.tuple([Encoder.list(Coord.encoder)], (move) => [move.coords.toList()], (value) => QuebecCastlesDrop.of(value[0]));
    static of(coords) {
        const asSet = new Set(coords);
        return new QuebecCastlesDrop(asSet);
    }
    constructor(coords) {
        super();
        this.coords = coords;
    }
    toString() {
        return 'QuebecCastlesDrop(' + this.coords.toString() + ')';
    }
    equals(other) {
        if (other instanceof QuebecCastlesDrop) {
            return this.coords.equals(other.coords);
        }
        else {
            return false;
        }
    }
}
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var QuebecCastlesMove;
(function (QuebecCastlesMove) {
    function isTranslation(move) {
        return move instanceof QuebecCastlesTranslation;
    }
    QuebecCastlesMove.isTranslation = isTranslation;
    function isDrop(move) {
        return move instanceof QuebecCastlesDrop;
    }
    QuebecCastlesMove.isDrop = isDrop;
    function drop(coords) {
        return QuebecCastlesDrop.of(coords);
    }
    QuebecCastlesMove.drop = drop;
    function translation(start, end) {
        return QuebecCastlesTranslation.of(start, end);
    }
    QuebecCastlesMove.translation = translation;
    QuebecCastlesMove.encoder = Encoder.disjunction([
        QuebecCastlesMove.isTranslation,
        QuebecCastlesMove.isDrop,
    ], [
        MoveCoordToCoord.getEncoder(QuebecCastlesTranslation.of),
        QuebecCastlesDrop.encoder,
    ]);
})(QuebecCastlesMove || (QuebecCastlesMove = {}));
